import React from 'react';
import styled from 'styled-components';
import { FormHeaderProps } from './FormHeader.types';

export const FormHeader = styled((props: FormHeaderProps) => {
  const { tag, children, bordered, ...rest } = props;
  return React.createElement(tag, rest, children);
})`
  padding: 1% 0px;
  font-family: 'Roboto', sans-serif;
  border: none;
  border-bottom: ${props => props.bordered ? `1px solid #BDC9CC` : 'none'};
  font-weight: bold;
  @media (max-width: 1000px) {
    font-family: 'Roboto', sans-serif;
    font-size: 120%;
    padding: 1% 2%;
  }
`;
